export const FILTER_BY_PARKS = "FILTER_BY_PARKS";
export const FILTER_BY_BIKES = "FILTER_BY_BIKES";


export const REQUEST_ALL_BIKE_STATIONS = "REQUEST_ALL_BIKE_STATIONS";
export const RECEIVE_ALL_BIKE_STATIONS = "RECEIVE_ALL_BIKE_STATIONS";
export const GET_ALL_BIKE_STATIONS_ERROR = "GET_ALL_BIKE_STATIONS_ERROR";
export const TOGGLE_BIKE_STATION_INFOWINDOW = "TOGGLE_BIKE_STATION_INFOWINDOW";

export const REQUEST_NEARBY_BIKE_STATIONS = "REQUEST_NEARBY_BIKE_STATIONS";
export const RECEIVE_NEARBY_BIKE_STATIONS= "RECEIVE_NEARBY_BIKE_STATIONS";
export const GET_NEARBY_BIKE_STATIONS_ERROR = "GET_NEARBY_BIKE_STATIONS_ERROR";

export const RECENTER_MAP ="RECENTER_MAP";
export const ZOOM_MAP = "ZOOM_MAP";

export const REQUEST_STATION_SEARCH= "REQUEST_STATION_SEARCH";
export const RECEIVE_STATION_SEARCH = "RECEIVE_STATION_SEARCH";
export const NO_STATION_FOUND = "NO_STATION_FOUND";
export const NO_SEARCH_TERM = "NO_SEARCH_TERM";




// WEBPACK FOOTER //
// ./src/actions/actionTypes.js